import { Component, Input } from '@angular/core';
import { IEmployee } from '../employee';
export class EmployeeComponent {

	 employee: IEmployee;
	 hasManager = false;
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
	selector: 'oc-employee',
	template: "<div class=\"oc-h-bar oc-border\" *ngIf=\"hasManager\"></div> <div class=\"oc-box oc-border oc-background\"> <div class=\"oc-img\"><img src=\"{{employee?.img}}\"/></div> <div class=\"oc-content\"><div class=\"oc-name\">{{employee?.name}}</div> <div class=\"oc-designation\">{{employee?.designation}}</div> </div> </div> <div class=\"oc-h-bar oc-border\" *ngIf=\"employee?.subordinates.length\"></div> ",
	styles: [":host { margin: 0 1em; display: flex; flex-direction: column; align-items: center; } .oc-box { padding: 0.25em 1em; display: flex; flex-direction: column; align-items: center; } .oc-h-bar { height: 0.5em; } .oc-content{ display:flex; flex-direction:column; padding: 0.25em 0.5em; } "]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'employee': [{ type: Input },],
'hasManager': [{ type: Input },],
};
}

function EmployeeComponent_tsickle_Closure_declarations() {
/** @type {?} */
EmployeeComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
EmployeeComponent.ctorParameters;
/** @type {?} */
EmployeeComponent.propDecorators;
/** @type {?} */
EmployeeComponent.prototype.employee;
/** @type {?} */
EmployeeComponent.prototype.hasManager;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
